import { createFileRoute } from '@tanstack/react-router';

import { getCompanyQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/domains/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/domains')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Domains',
    tabKey: 'client/domains',
  },
  pendingComponent: Loading,
});
